module.exports = __webpack_public_path__ + "static/img/AI-8.423076a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AI-8.jpg
// module id = LeK7
// module chunks = 46